module.exports = __webpack_public_path__ + "495a4c1d8cbf8199d29a1070af8f2799.svg";